module.exports = __webpack_public_path__ + "img/ico-home.ce98d59d.svg";